function discontinuitySequence(str) {
  return parseInt(str) || 0;
}

module.exports = discontinuitySequence;
